import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { Container, Row, Col, Button, Nav, NavItem, NavLink } from 'reactstrap'
import Reference from '../components/reference'
import containerShip from './images/graphics/container-ship.svg'
import browserStats from './images/graphics/undraw_browser_stats_704t.svg'
import buildingBlocks from './images/graphics/undraw_building_blocks_n0nc.svg'
import choose from './images/graphics/undraw_choose_80qg.svg'

const LeistungenPage = () => (
  <div>
    <Helmet
      title={`Webseiten, Webapplikationen und Anwendungssoftware aus Oberösterreich`}
      meta={[
        { name: 'description', content: 'Webseiten, Webapplikationen, Anwendungssoftware, Cloud-Anwendungen und mehr. Von der Idee zur Lösung.' },
        { name: 'keywords', content: 'homepage, webseite, website, cloud, software, webapplikation, anwendungssoftware, automatisierung' },
      ]}
    />

    <section className="bg evelope">
      <Container>
        <Row className="align-items-center py-5 py-md-7 py-lg-8">
          <Col md="6" className="order-12 order-md-1">
            <h1>Leistungen.</h1>
            <p className="lead my-5">
              Eine gute Idee alleine reicht leider nicht. Ihre Idee soll auch auf einem soliden Fundament aufgebaut sein und ich unterstütze Sie dabei.
            </p>
          </Col>
          <Col md="6" className="order-1 order-md-12">
            <img src={buildingBlocks} className="img-fluid p-5 p-md-0" alt="Leistungen" />
          </Col>
        </Row>
      </Container>
    </section>
    
    <section className="py-4 py-5">
      <Container>
        <Row className="text-lg-center">
          <Col className="py-4 py-lg-7" lg="4">
            <h2 className="text-uppercase">Webapplikationen</h2>
            <p className="mt-4 lead">
              Maßgeschneiderten Webapplikationen nach Ihren Anforderungen. Ein E-Commerce System mit der Ihre Kunden rund um die Uhr Ihre Produkte kaufen können. Oder eine Web-Plattform mit der Sie bestimmte Prozesse vereinfachen bzw. automatisieren.
            </p>
          </Col>

          <Col className="py-4 py-lg-7" lg="4">
            <h2 className="text-uppercase">Webseiten</h2>
            <p className="mt-4 lead">
              Überzeugen Sie Ihre Kunden rund um die Uhr mit einem professionellen Online-Auftritt. Aktualisieren Sie Ihre Seiten jederzeit selbstständig, ganz unkompliziert.
            </p>
          </Col>

          <Col className="py-4 py-lg-7" lg="4">
            <h2 className="text-uppercase">Anwendungssoftware</h2>
            <p className="mt-4 lead">
              Wiederkehrende Prozesse von einer Software erledigen lassen - mit weniger Fehlern und erhöhter Effizienz. Wir suchen gemeinsam nach der optimalen Lösung für die Automatisierung Ihrer Prozesse - samt Implementierung und Wartung.
            </p>
          </Col>
        </Row>
      </Container>
    </section>

    <section className="bg radient border-top border-bottom">
      <Container>
        <Row className="py-7">
          <Col>
            <Row>
              <Col lg="9">
                <h2>Moderne Technologien.</h2>
                <p className="lead mt-5">
                  Jedes Projekt hat unterschiedliche Anforderungen. Damit Ihr Projekt auf soliden Beinen 
                  steht ist es wichtig zu Beginn die optimale Technologie entsprechend Ihren Anforderungen auszuwählen. 
                  Falls Sie sich für technische Details interessieren, hier ein Auszug meiner bevorzugten Technologien.
                </p>
              </Col>
            </Row>

            <Row>
              <Col xs="6" lg="3" className="mt-5">
                <h6 className="text-uppercase">Webapplikationen</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/">Elixir / Phoenix</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Java / Spring Boot</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">PHP / Laravel</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Python</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">JavaScript / React</NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col xs="6" lg="3" className="mt-5">
                <h6 className="text-uppercase">Webseiten</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/">OctoberCMS</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Wordpress</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">GatsbyJS</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Bootstrap</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">JQuery</NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col xs="6" lg="3" className="mt-5">
                <h6 className="text-uppercase">Datenbanken</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/">PostgreSQL</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="#">MySQL</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="#">Oracle</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="#">DynamoDB</NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col xs="6" lg="3" className="mt-5">
                <h6 className="text-uppercase">Anwendungssoftware</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/">C# / WPF</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="#">Java / JavaFX</NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="pb-7">
          <Col>
            <Row>
              <Col lg="9">
                <h4 className="text-uppercase">Cloud-Computing</h4>
                <p className="lead pt-4">
                  Mit Amazon Web Services ist es möglich eine ganze Serverinfrastruktur zu 
                  konfigurieren. Um die Software dann möglichst portabel zu halten werden Docker 
                  Container eingesetzt.
                  Und manchmal kommt man auch ganz ohne Server aus - <strong>Serverless</strong> sozusagen. 
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs="6" lg="4" className="mt-5">
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/">CloudFormation</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="#">Elastic Beanstalk</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Lambda</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Simple Queue Service</NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col xs="6" lg="4" className="mt-5">
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/">Route 53</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">DynamoDB</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">API Gateway</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">S3</NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col xs="6" lg="4" className="mt-5">
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/">RDS</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Cognito</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/">Cloudfront</NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
    
    <section className="sls-block">
      <div className="bg-image m-6 left-25 d-none d-md-block" style={{backgroundImage: `url(${choose})`, backgroundSize: 'contain'}}>
      </div>

      <Container>
        <Row className="py-7 justify-content-end align-items-center">
          <Col md="8" xl="9">
            <h2>Qualität durch testgetriebene Entwicklung.</h2>
            <p className="lead pt-4">
              Der geschickte Einsatz von automatisierten Softwaretests hilft dabei hochwertige 
              Software zu implementieren und potentielle Fehler frühzeitig zu beheben. Daher arbeite ich nach 
              dem Vorgehensmodell des Test Driven Developments (TDD) oder testgetriebener Entwicklung. 
              Dadurch findet die Qualitätssicherung nicht erst am Ende der Entwicklung statt und spart somit 
              Zeit und Kosten.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  </div>
)

export default LeistungenPage



// WEBPACK FOOTER //
// ./src/pages/leistungen.js